import styled from "styled-components/macro";

import { AccordionItem } from "components/AccordionItem";
import type { ThemeProps } from "models/styles/theme";
import { CssButton, CssFlex, CssGrid, CssIcon } from "styles/helpers/layout";
import { calculateRem } from "styles/mixins/calculateRem";

import { AccessibilityMenuButton } from "components/AccessibilityMenuButton/AccessibilityMenuButton";
import { SvgIconReact } from "components/SvgIconReact";

export const StyledNavigationMenu = styled.nav<ThemeProps>`
  max-height: 100%;
  overflow-y: auto;
  color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  scrollbar-color: ${(props: ThemeProps) => props.theme.palette.secondary._700} transparent;
  scrollbar-width: thin;
`;

export const StyledNavigationItemGroup = styled(AccordionItem)<ThemeProps>`
  .tab-label .tab-title .tab-title-text {
    font-size: ${(props: ThemeProps) => props.theme.font.size._16};
    letter-spacing: initial;
    color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  }
  .tab-label {
    padding: 1rem 1.5rem;
  }
  .tab-content {
    padding-left: 0.5rem;
    padding-right: 0;
    background-color: transparent;
  }
`;

export const StyledOnboardingButton = styled(CssButton)<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};

  :hover {
    color: ${(props: ThemeProps) => props.theme.palette.neutral._600};
    font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  }
`;

export const StyledNavigationContainer = styled(CssGrid)<ThemeProps>`
  background-color: ${(props: ThemeProps) => props.theme.palette.secondary.brand};
  border-right: 1px solid ${(props) => props.theme.palette.secondary.brand};
  padding: 1rem 0.5rem;
  width: 300px;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  row-gap: 1rem;
`;

export const StyledButton = styled(CssButton)<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};
  margin-bottom: 1.5rem;
  margin-left: 1rem;
  text-align: left;
  background-color: transparent;

  :hover {
    color: ${(props: ThemeProps) => props.theme.palette.secondary.brand};
    font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
    background-color: unset;
  }

  .content {
    display: grid;
    grid-template-columns: ${calculateRem(23)} 1fr;
    column-gap: 1rem;
    align-items: center;
    justify-items: left;
    color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  }
`;

export const StyledProfileButton = styled(CssFlex)<ThemeProps>`
  padding-top: 1rem;
  cursor: pointer;
  border-top: 0.8px solid ${(props: ThemeProps) => props.theme.palette.secondary._900};
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  i {

    color: ${(props: ThemeProps) => props.theme.palette.red.brand};
  }
  p {
    color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  }
`;

export const StyledLogo = styled(SvgIconReact)`
  height: 2rem;
  width: 12rem;
  margin-left: 1.5rem;
`;

export const StyledLogoContainer = styled(CssFlex)<ThemeProps>`
  padding-bottom: 1rem;
  border-bottom: ${({ theme }: ThemeProps) => `0.8px solid ${theme.palette.secondary._800}`};
`;

export const StyledNavigationBottomContainer = styled(CssFlex)`
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledNavigationItemName = styled(CssGrid)`
  grid-template-columns: ${calculateRem(23)} 1fr auto;
  column-gap: 1rem;
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};
  align-items: center;
`;

export const StyledOrphanNavigationItemName = styled(StyledNavigationItemName)`
  padding: 1rem 0.5rem;
`;

export const StyledIcon = styled(CssIcon)`
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  align-self: center;
  justify-self: center;
`;

export const StyledDropdownIcon = styled(CssIcon)`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  pointer-events: none;
  transition: transform 0.35s ease;

  .accordion-expanded & {
    transform: rotate(180deg);
  }
`;

export const StyledAccessibilityMenuButton = styled(AccessibilityMenuButton)<ThemeProps>`
  padding: 1rem 0 1.5rem 1rem;
  border-top: 0.8px solid ${(props: ThemeProps) => props.theme.palette.secondary._900};
  padding-top: 1rem;
  margin: 0;
  border-radius: 0;
  .content {
    display: grid;
    grid-template-columns: ${calculateRem(23)} 1fr;
    column-gap: 1rem;
    align-items: center;
    justify-items: left;
    > :first-child
    {
      align-self: center;
      justify-self: center;
    }
  }
`;

export const StyledProfileIcon = styled.div<ThemeProps>`
  background-color: ${(props: ThemeProps) => props.theme.palette.secondary._700};
    padding: 0.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 1rem;
  i {
    color: ${(props: ThemeProps) => props.theme.palette.red.brand};
    font-size: ${(props: ThemeProps) => props.theme.font.size._18};
  }
`;
